import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Chip,
  Grid,
  ListSubheader,
  Typography,
} from "@mui/material";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import AccessTime from "@mui/icons-material/AccessTime";
import CalendarToday from "@mui/icons-material/CalendarToday";
import ErrorOutline from "@mui/icons-material/ErrorOutline";
import Message from "@mui/icons-material/Message";
import MoreVert from "@mui/icons-material/MoreVert";
import Place from "@mui/icons-material/Place";
import React from "react";
import ConfirmDialog from "./ConfirmDialog";
import CreateOrUpdateAddDialog from "./CreateOrUpdateAddDialog";
import JobRequestInterestDialog from "./JobRequestInterestDialog";
import Hidden from "@mui/material/Hidden";
import { getCategoryById } from "./categoryHelper";

export default function JobRequestCard(props) {
  const userProfile = props.userProfile;
  const job = props.job;
  const cert = job["id06"] && "ID06";
  const company = job.company;
  const date = job.startNow === "startNow" ? " Omgående" : job.startDate;
  //const date = job.startDate;
  //const jobLength = job.jobLength === 1 ? "1 dag" : job.jobLength + " dagar";
  const county = job.county;
  const municipality = job.municipality;
  //const title = job.title;

  const [isOpen, setIsOpen] = React.useState(false);

  const closeDialog = () => {
    setIsOpen(false);
  };
  const [confirmDialog, setConfirmDialog] = React.useState({
    isOpen,
    title: "",
    id: "",
    subtitle: "",
  });

  const description = job.description;
  const [anchorEl, setAnchorEl] = React.useState(null);

  async function handleDelete() {
    setConfirmDialog({
      isOpen: true,
      id: job.id,
      title: "Ta bort annons",
      subtitle:
        "Det här kommer ta bort annonsen permanant. Du har ingen möjlighet att återskapa den.",
    });
    handleClose();
    //props.getAddsByUser(userProfile);
  }
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Card style={{ background: "white", marginTop: "30px" }} key={job.id}>
      <CardHeader
        sx={{ pl: 1, pt: 1, pb: 1 }}
        action={
          (props.admin === true && (
            <>
              <Chip
                color="primary"
                label={getCategoryById(job.category).label}
              />
              <IconButton aria-label="settings" onClick={handleClick}>
                <MoreVert />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem
                  onClick={() => {
                    setIsOpen(true);
                    handleClose();
                  }}
                >
                  Ändra
                </MenuItem>
                <MenuItem onClick={handleDelete}>Ta bort</MenuItem>
              </Menu>
            </>
          )) || (
            <Chip color="primary" label={getCategoryById(job.category).label} />
          )
        }
        title={company}
      />
      <CardContent style={{ padding: 1 }}>
        <div style={{ marginBottom: "10px", marginLeft: "5px" }}>
          {/*<Chip color="primary" label={getCategoryById(job.category).label} />*/}
          {job.subCategories &&
            job.subCategories.map(function (sub) {
              return (
                <Chip
                  label={sub}
                  size="small"
                  style={{ marginLeft: "5px", marginBottom: "5px" }}
                />
              );
            })}
        </div>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={3}>
            <span
              style={{
                display: "flex",
                alignItems: "center",
                color: "rgba(0,0,0,0.54)",
                fontSize: "14px",
              }}
            >
              <Place />
              {municipality}
              {", "}
              {county}
            </span>
          </Grid>
          <Grid item xs={5} sm={3}>
            <span
              style={{
                display: "flex",
                alignItems: "center",
                color: "rgba(0,0,0,0.54)",
                fontSize: "14px",
              }}
            >
              <CalendarToday />
              {date}
            </span>
          </Grid>
          {/*<Grid item xs={4} sm={3}>
            <span
              style={{
                display: "flex",
                alignItems: "center",
                color: "rgba(0,0,0,0.54)",
                justifyContent: "flex-start",
                fontSize: "14px",
              }}
            >
              <AccessTime />
              {jobLength}
            </span>
          </Grid>
          */}
          <Grid item xs={3} sm={3}>
            {cert && (
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "rgba(0,0,0,0.54)",
                  fontSize: "14px",
                }}
              >
                <ErrorOutline /> {cert}
              </span>
            )}
          </Grid>
        </Grid>
      </CardContent>
      <CardContent>
        <Grid container>
          <Grid item xs={12}>
            <div>{description}</div>
          </Grid>
        </Grid>
      </CardContent>

      <CardActions>
        <div>
          {props.admin === false && (
            <JobRequestInterestDialog
              key={job.id}
              job={job}
              userProfile={userProfile}
            />
          )}
          {props.admin === true && (
            <>
              <CreateOrUpdateAddDialog
                job={job}
                isOpen={isOpen}
                closeDialog={closeDialog}
                updateAdFunc={props.updateAdFunc}
              />
              <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
                refreshFunc={props.getAddsByUser}
                whatToDelete="ad"
                message="Din annons har tagits bort!"
              />

              <ResponseList
                key={job.id}
                items={
                  (job.jobRequestComments && job.jobRequestComments.items) || []
                }
              />
            </>
          )}
        </div>
      </CardActions>
    </Card>
  );
}

function ResponseList(props) {
  const items = props.items;
  const hasItems = items.length > 0;

  return (
    <List>
      {hasItems && <ListSubheader>Svar på annonsen</ListSubheader>}

      {hasItems === false && (
        <ListSubheader>Annonsen saknar svar</ListSubheader>
      )}

      {hasItems &&
        items.map(function (comment) {
          return (
            <ListItem key={comment.id}>
              <List>
                <ListItem style={{ paddingLeft: "0", paddingRight: "0" }}>
                  <ListItemAvatar>
                    <Avatar>
                      <Message />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={comment.message}
                    secondary={
                      <>
                        {new Date(comment.createdAt).toLocaleDateString()}{" "}
                        {comment.userFirstName} {comment.userLastName},{" "}
                        {comment.userCompany}{" "}
                        <Hidden smUp>
                          {" "}
                          <br />
                        </Hidden>
                        <a
                          style={{ color: "inherit" }}
                          href={"tel:" + comment.userPhone}
                        >
                          {" "}
                          {comment.userPhone}
                        </a>{" "}
                        <a
                          style={{ color: "inherit" }}
                          href={"mailto:" + comment.userEmail}
                          target="_new"
                        >
                          {" "}
                          {comment.userEmail}
                        </a>
                      </>
                    }
                  ></ListItemText>
                </ListItem>
              </List>
            </ListItem>
          );
        })}
    </List>
  );
}
